$('[data-toggle="menu"]').click(function(){
	var topo = document.querySelector('.topo');

	var bgTopo = document.createElement('div');

	$(bgTopo).addClass('bg-topo');

	$(bgTopo).click(function(){
		$('.topo-content').removeClass('active');

		$('.bg-topo').fadeOut(600, function (){
			$(this).remove();
		});
	})

	$('.topo-content').addClass('active');

	topo.appendChild(bgTopo);

	$(bgTopo).fadeIn(600);
});